(function($) {

	windowWidth = $(window).width();
	
	/*
	* scroll
	*/
	$(function(){
		// #で始まるアンカーをクリックした場合に処理
		$('a[href^="#"]').click(function() {
			// スクロールの速度
			var speed = 300; // ミリ秒
			// アンカーの値取得
			var href= $(this).attr("href");
			// 移動先を取得
			var target = $(href == "#" || href == "" ? 'html' : href);
			// 移動先を数値で取得
			if (windowWidth <= 768) {
				var adjust = 0;
			} else{
				var adjust = 0;
			}
			var position = target.offset().top - adjust;
			// スムーススクロール
			$('body,html').animate({scrollTop:position}, speed, 'swing');
			return false;
		});
	});
	
	urlHash = location.hash;
	$(window).on('load hashchange',function(){
		var urlHash = location.hash;
	
		if(urlHash) {
			var target = $(urlHash);
			if (windowWidth <= 768) {
				var adjust = 0;
			} else{
				var adjust = 0;
			}
			var position = target.offset().top - adjust;
			$.when(
				$("html, body").animate({
					scrollTop: position
				}, 500, "swing"),
			).done(function() {
				var diff = target.offset().top - adjust;
				if (diff === position) {
				} else {
					$("html, body").animate({
						scrollTop: diff
					}, 10, "swing");
				}
			});
		}
	});
	
	
	/*
	* css swicher
	*/
	function css_browser_selector(u){
		var ua=u.toLowerCase(),
		is=function(t){return ua.indexOf(t)>-1},
		e='edge',g='gecko',w='webkit',s='safari',o='opera',m='mobile',
		h=document.documentElement,
		b=[
			( !(/opera|webtv/i.test(ua)) && /msie\s(\d)/.test(ua))? ('ie ie'+RegExp.$1) :
				!(/opera|webtv/i.test(ua)) && is('trident') && /rv:(\d+)/.test(ua)? ('ie ie'+RegExp.$1) :
				is('edge/')? e:
				is('firefox/2')?g+' ff2':
				is('firefox/3.5')? g+' ff3 ff3_5' :
				is('firefox/3.6')?g+' ff3 ff3_6':is('firefox/3')? g+' ff3' :
				is('gecko/')?g:
				is('opera')? o+(/version\/(\d+)/.test(ua)? ' '+o+RegExp.$1 :
				(/opera(\s|\/)(\d+)/.test(ua)?' '+o+RegExp.$2:'')) :
				is('konqueror')? 'konqueror' :
				is('blackberry')?m+' blackberry' :
				is('android')?m+' android' :
				is('chrome')?w+' chrome' :
				is('iron')?w+' iron' :
				is('applewebkit/')? w+' '+s+(/version\/(\d+)/.test(ua)? ' '+s+RegExp.$1 : '') :
				is('mozilla/')? g:
				'',
				is('j2me')?m+' j2me':
				is('iphone')?m+' iphone':
				is('ipod')?m+' ipod':
				is('ipad')?m+' ipad':
				is('mac')?'mac':
				is('darwin')?'mac':
				is('webtv')?'webtv':
				is('win')? 'win'+(is('windows nt 6.0')?' vista':''):
				is('freebsd')?'freebsd':
				(is('x11')||is('linux'))?'linux':
				'',
				'js'];
		c = b.join(' ');
		h.className += ' '+c;
		return c;
	};
	css_browser_selector(navigator.userAgent);
	
	
	
	
	
	
	/*
	* fade
	*/
	$(function() {
		if (windowWidth <= 768) {
			intersectAction($('.fade'), function (element, isIntersecting) {
				if (isIntersecting) {
					element.addClass('fade-on')
				}
			}, { rootMargin: "0px 0px -40% 0px" }); //　画面下から20%で発火
		} else{
			intersectAction($('.fade'), function (element, isIntersecting) {
				if (isIntersecting) {
					element.addClass('fade-on')
				}
			}, { rootMargin: "0px 0px -25% 0px" }); //　画面下から20%で発火
		}
	});
	
	
	
	/*
	* accordion
	*/
	$(function () {
		$('.faq_box .faq_ttl').click(function(event){
			$(this).toggleClass('open');
	
			if ($(this).next('.faq_txt').css('display') == 'none') {
				$(this).next('.faq_txt').slideDown('fast');
			} else {
				$(this).next('.faq_txt').slideUp('fast');
			}
	
			event.stopPropagation();
		});
	});
	
	
	
	
	$(function () {
  // モーダルを開く処理
  $('.js-youtube').on('click', function () {
    const id = $(this).data('video-id');
    if (!id) return;

    // YouTube埋め込みURLのパラメータ（音あり自動再生）
    const params = [
      'autoplay=1',    // 自動再生
      'mute=0',        // ミュート解除
      'playsinline=1', // iOS Safariでインライン再生
      'rel=0',         // 関連動画非表示
      'enablejsapi=1',  // JS API有効化
	  'cc_load_policy=0' //字幕オフ
    ].join('&');

    // iframe要素を生成（allow属性に autoplay を明記）
    const iframeHtml =
      '<iframe width="568" height="1010" ' +
      'src="https://www.youtube.com/embed/' + id + '?' + params + '" ' +
      'frameborder="0" ' +
      'allow="autoplay; encrypted-media; picture-in-picture" ' +
      'allowfullscreen></iframe>';

    // data-video-aspect 属性を取得
    const aspect = $(this).data('video-aspect');
    const isHorizontal = aspect === 'horizontal';

    $('.js-movie-modal-body').html(iframeHtml);

    $('.js-movie-modal')
      .addClass('is-active')
      .toggleClass('horizontal', isHorizontal)
      .attr('aria-hidden', 'false');
  });

  // モーダルを閉じる関数
  function closeModal() {
    $('.js-movie-modal')
      .removeClass('is-active horizontal')
      .attr('aria-hidden', 'true');
    // 中のiframeを削除して動画と音声を完全停止
    $('.js-movie-modal-body').empty();
  }

  // 閉じるボタンおよびオーバーレイ（背景）クリックで閉じる
  $('.js-movie-modal-close').on('click', closeModal);

  // Escキー入力で閉じる
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $('.js-movie-modal').hasClass('is-active')) {
      closeModal();
    }
  });
});
	
	
	$(function () {
  const $floatingBtn = $('.js-floatingBtn');
  const $startTrigger = $('.floating-btn_start').first();
  const $debut = $('.debut').first();

  // 要素が存在しない場合は処理を終了
  if (!$floatingBtn.length || !$startTrigger.length || !$debut.length) return;

  // 表示開始位置のオフセット（この分だけ遅らせて表示）
  const startOffset = 100;

  /**
   * スクロール位置に応じて表示/非表示を制御
   */
  function checkScrollPosition() {
    const windowHeight = $(window).height();
    const scrollTop = $(window).scrollTop();
    const startTop = $startTrigger.offset().top + startOffset; // 100px遅らせる
    const debutTop = $debut.offset().top;

    const windowBottom = scrollTop + windowHeight;

    // 表示開始位置に到達 かつ debutに到達していない場合のみ表示
    if (windowBottom >= startTop && windowBottom < debutTop) {
      $floatingBtn.addClass('is-visible');
    } else {
      $floatingBtn.removeClass('is-visible');
    }
  }

  // スクロール・リサイズ時に判定（スロットリング付き）
  let ticking = false;
  $(window).on('scroll resize', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        checkScrollPosition();
        ticking = false;
      });
      ticking = true;
    }
  });

  // 初期表示時にも判定
  checkScrollPosition();
});
	
	})(jQuery);